import { h } from "preact";
import WalletRoot1 from "../../../components/routes/wallet-root-1";
import { useExternalActionHandler } from "../../../hooks/external-action-handler";
import { useActionEmitter } from "../../../hooks/action-emitter";
import { useRouterActionHandler } from "../../../hooks/router";
import { useAnalytics } from "../../../hooks/analytics";
import { useWalletConfig } from "../../../hooks/client-configurations";
import { useWalletScreenManager } from "../../../hooks/wallet-screen-manager";
import { ErrorWrapper } from "../error-wrapper";

export interface IWalletWrapper {
  type_id: "WALLET_WRAPPER";
  filter: {};
  fragment: {
    rootId: string;
  };
}

export function WalletWrapper({ fragment }: IWalletWrapper) {
  const [walletConfig] = useWalletConfig();
  const [rootId, root, selectedFragment] = useWalletScreenManager(
    walletConfig,
    fragment
  );
  const [onExternalAction] = useExternalActionHandler();
  const [onRouterAction] = useRouterActionHandler();
  const [onAnalyticsAction] = useAnalytics({
    rootTypeId: root?.type_id,
    rootId: rootId,
  });
  const [status, emit, onAction] = useActionEmitter(
    [onExternalAction, onRouterAction, onAnalyticsAction],
    null
  );

  if (root?.type_id === "WALLET_ROOT_1") {
    return (
      <WalletRoot1 {...root} onAction={onAction} screen={selectedFragment} />
    );
  } else {
    return (
      <ErrorWrapper
        status={{ state: "LOAD_ERROR", message: "wallet not found" }}
      />
    );
  }
}
